import { useState } from "react";

const useOpenDropdown = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = (event: React.BaseSyntheticEvent) => {
    setOpen((prev) => !prev);
    event.preventDefault();
  };

  return {
    open,
    setOpen,
    handleOpen,
  };
};

export default useOpenDropdown;
